<template>
    <v-dialog @keydown.esc="close()" v-model="dialog" persistent width="90%" max-width="600px" min-width="350px">
        <v-card>
            <v-card-title>
                Regras
            </v-card-title>
            <v-card-text>
                <ul v-if="isLoyaltyTypeValue">
                    <li>Você ganha um ponto a cada: R$ {{ pointsValue }} consumidos.</li>

                    <li>Os pontos gerados em cada compra não expiram.</li>

                    <li>Os pontos são pessoais e intransferíveis.</li>

                    <li>Os vouchers gerados para resgate de qualquer promoção, oferta ou recompensa são pessoais e
                        intransferíveis, e só poderão ser resgatados por quem os gerou.</li>

                    <li v-if="currentCompany.integrated">Lembrando que se não resgatar o produto na loja em dois dias, o
                        resgate sera estornado.</li>

                    <li v-if="currentCompany.id == 3">Regras de compra mínima.
                        <ul>
                            <li>R$ 30,00 vale Lity -> compra mínima de R$100,00</li>
                            <li>R$ 50,00 vale Lity -> compra mínima de R$ 150,00</li>
                            <li>R$ 70,00 vale Lity -> compra mínima de R$ 200,00</li>
                            <li>R$ 300,00 vale Lity -> compra mínima de R$ 500,00</li>
                        </ul>
                    </li>
                </ul>

                <ul v-if="!isLoyaltyTypeValue">
                    <li>Você ganha {{ pointsPerVisit }} pontos a cada visita.</li>

                    <li>Os pontos gerados em cada visita não expiram.</li>

                    <li>Os pontos são pessoais e intransferíveis.</li>

                    <li>Os vouchers gerados para resgate de qualquer promoção, oferta ou recompensa são pessoais e
                        intransferíveis, e só poderão ser resgatados por quem os gerou.</li>

                    <li v-if="currentCompany.integrated">Lembrando que se não resgatar o produto na loja em dois dias, o
                        resgate sera estornado.</li>

                    <li v-if="currentCompany.id == 3">Regras de compra mínima.
                        <ul>
                            <li>R$ 30,00 vale Lity -> compra mínima de R$100,00</li>
                            <li>R$ 50,00 vale Lity -> compra mínima de R$ 150,00</li>
                            <li>R$ 70,00 vale Lity -> compra mínima de R$ 200,00</li>
                            <li>R$ 300,00 vale Lity -> compra mínima de R$ 500,00</li>
                        </ul>
                    </li>
                </ul>
            </v-card-text>
            <v-card-actions class="flex-row-end">
                <v-btn class="text-none" text color="var(--cor--cinzaApp)" @click="close()"> Fechar </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getCompanyLoyaltyByCompanyId } from "./service/rules-modal.service";

export default {
    name: 'RulesModal',
    computed: {
        ...mapGetters('authenticateStore', {
            currentCompany: 'get_currentCompany',
            isLoggedIn: 'isLoggedIn'
        }
        )
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        isLoyaltyTypeValue: true,
        pointsPerVisit: null,
        pointsValue: null

    }),
    created() {
        this.getLoyaltyType()
    },
    methods: {
        close() {
            this.$emit("closeRulesModal", false);
        },
        getLoyaltyType() {
            getCompanyLoyaltyByCompanyId(this.currentCompany.id)
                .then(success => {
                    this.isLoyaltyTypeValue = success.data.companyLoyaltyTypeId == 1;
                    this.pointsPerVisit = success.data.points
                    this.pointsValue = success.data.minValue
                }
                )
                .catch(error => {
                    if (error != null) {
                        this.$toasted.show(error.message, { type: 'error' })
                    }
                }
                )
        }
    }
}
</script>

<style scoped>
li {
    margin: 10px 0;
}
</style>